export default __webpack_public_path__ + "static/media/bg1.36b4c010.png";